import React from 'react';
import { SirenIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { useDocumentMeta } from '../hooks/useDocumentMeta';
import { site } from '../data/site';
import { container, focusRing } from '../utils/styles';
import { PageHeader } from '../components/shared/PageHeader';
import { ContactOptions } from '../components/shared/ContactOptions';
import { ContactForm } from '../components/shared/ContactForm';
import { ServiceAreaSection } from '../components/shared/ServiceAreaSection';
export function Contact() {
  const {
    t
  } = useLanguage();
  useDocumentMeta('contact');
  return <>
      <PageHeader crumb={t({
      en: 'Contact',
      es: 'Contacto'
    })} title={t({
      en: 'Schedule a Free Consultation',
      es: 'Agenda una Consulta Gratuita'
    })} intro={t({
      en: 'Call, send a WhatsApp message, or fill out the form. We answer 24/7, in English or Spanish.',
      es: 'Llama, envía un mensaje por WhatsApp o completa el formulario. Respondemos 24/7, en inglés o español.'
    })} data-id="element-514" data-mp="17ra9u3vulazw" />

      <section className="bg-cream py-16 sm:py-20" aria-label={t({
      en: 'Contact options',
      es: 'Opciones de contacto'
    })} data-id="element-515" data-mp="15dm6p7xtp1bb">
        <div className={`${container} grid gap-12 lg:grid-cols-12 lg:gap-16`} data-id="element-516" data-mp="1e80mrcq6gfvh">
          <div className="order-2 lg:order-1 lg:col-span-5" data-id="element-517" data-mp="1ea3a1ozy3uwi">
            <ContactOptions data-id="element-518" data-mp="1j6bu9gt02eaj" />
            <div className="mt-8 flex gap-4 rounded-2xl border-2 border-red-200 bg-white p-6" role="note" data-id="element-519" data-mp="1j8o9vnbacckf">
              <SirenIcon className="mt-0.5 h-6 w-6 shrink-0 text-red-700" aria-hidden="true" data-id="element-520" data-mp="qi68qru4gl9n" />
              <div data-id="element-521" data-mp="qjzf060tp3h4">
                <h2 className="font-sans text-lg font-bold text-ink" data-id="element-522" data-mp="vhixji4k02ev">{t({
                  en: 'Emergency contact',
                  es: 'Contacto de emergencia'
                })}</h2>
                <p className="mt-1 text-ink-soft" data-id="element-523" data-mp="10h56hfdcmwhv">
                  {t({
                  en: 'For a medical emergency, call 911 first. Current clients with urgent care needs can reach our on-call team 24/7 at',
                  es: 'En una emergencia médica, llama primero al 911. Clientes actuales con necesidades urgentes pueden comunicarse con nuestro equipo de guardia 24/7 al'
                })}{' '}
                  <a href={site.tel} className={`rounded font-bold text-brand-dark underline ${focusRing}`} data-id="element-524" data-mp="1h80rl0v6kmh0">
                    {site.phoneDisplay}
                  </a>
                  .
                </p>
              </div>
            </div>
          </div>
          <div className="order-1 rounded-2xl bg-white p-6 shadow-[0_2px_24px_rgba(44,62,80,0.07)] sm:p-10 lg:order-2 lg:col-span-7" data-id="element-525" data-mp="13g2qndbmhwvx">
            <h2 className="text-2xl font-bold text-ink sm:text-3xl" data-id="element-526" data-mp="yjm0yeorzagq">
              {t({
              en: 'Request your consultation',
              es: 'Solicita tu consulta'
            })}
            </h2>
            <p className="mb-7 mt-2 text-ink-soft" data-id="element-527" data-mp="18exggz80clpj">
              {t({
              en: 'Tell us a little about your loved one and when you’d like to talk. Fields marked * are required.',
              es: 'Cuéntanos un poco sobre tu ser querido y cuándo te gustaría hablar. Los campos con * son obligatorios.'
            })}
            </p>
            <ContactForm showScheduling idPrefix="contact-cf" data-id="element-528" data-mp="2rctnqbfx2weo" />
          </div>
        </div>
      </section>

      <ServiceAreaSection data-id="element-529" data-mp="2hggz3rz8b8qs" />
    </>;
}